import React, { Component } from "react";

class ListCommentPage extends Component {
  state = {};
  render() {
    return (
      <div
        className="pt-2 max_width_500"
        style={{
          width: "calc(100% - 16px)",
          marginRight: "8px",
          height: "20%"
        }}
      >
        <textarea
          style={{
            backgroundColor: "#f8f9fa",
            height: "100%",
            resize: "none",
            border: "none",
            padding: "10px",
            borderRadius: "10px",
            width: "100%"
          }}
          value={this.props.comment}
          onChange={event => this.props.handleChangeComment(event.target.value)}
          placeholder="Share Answer"
        />
      </div>
    );
  }
}

export default ListCommentPage;



// WEBPACK FOOTER //
// ./src/components/list/interface/page_question/list_comment_page.jsx